export default __webpack_public_path__ + "static/media/legal-documents-document.2d75d03e.svg";